import { useEffect, useCallback } from "react";
import { useNavigationActions } from "./useNavigationActions";

export const useGlobalKeyboardShortcuts = () => {
  const { triggerAddBookmark, triggerCreateCollection } = useNavigationActions();

  const handleKeyDown = useCallback((e) => {
    // Only handle shortcuts with Cmd/Ctrl modifier
    if (!(e.metaKey || e.ctrlKey)) return;

    switch (e.key.toLowerCase()) {
      case "b":
        // Command/Ctrl + B - New bookmark
        e.preventDefault();
        triggerAddBookmark();
        break;
        
      case "u":
        // Command/Ctrl + U - New collection
        e.preventDefault();
        triggerCreateCollection();
        break;
        
      // Skip Command/Ctrl + K to avoid conflict with existing search functionality
      default:
        break;
    }
  }, [triggerAddBookmark, triggerCreateCollection]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);
};